import React from 'react';
import Header from './components/shared/header';
import Footer from './components/shared/footer';

const App = ({ children }) => {
    const styles = {
        bodyContainer: {
            backgroundColor: '#fff',
            paddingLeft: 15,
            paddingRight: 15,
            paddingBottom: 15,
            paddingTop: 5
        }
    };
    return (
        <div>
            <div className="container">
                <div className="row">
                    <div className="col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                        <Header />
                        <div style={styles.bodyContainer}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};
App.propTypes = {
    children: React.PropTypes.element
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js